import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from 'src/environments/environment';
import { IAuditableEntity, IEntityBase } from "src/app/shared/models/model";
import { HttpParams } from "@angular/common/http";



@Injectable({providedIn: "root"})

export class ConfigurationService {

    private readonly dataGridUrl = `${environment.baseApiUrl}/DataGridState`;

    constructor(private httpService: HttpService) 
    {};
     
    public getDataGridStateByGridId = (GridId: string, UserId: number) => {
       return this.httpService.getData(`${this.dataGridUrl}/${GridId}/User/${UserId}`);
    }
    
    public addDataGridStateGridID = (DataGridState : IDataGridState) => {
        return this.httpService.post(`${this.dataGridUrl}`, DataGridState)
    }
}


// model for Data Grid State
export interface IDataGridState extends IEntityBase, IAuditableEntity {
    UserId: number | null;
    GridId: string;
    State: string;
};
